import React from "react";  
import DockConfigListPageContainer from "./DockConfigListPageContainer";

export class DockConfigPage extends React.Component {
  render() {
    return <DockConfigListPageContainer {...this.props} />;
  }
}
